export default "__VITE_ASSET__89f4996e__"